import React from 'react';

import { Link } from 'office-ui-fabric-react/lib/Link';
import { localizable } from '../../../components/Localization';

import DocPreview from './DocPreview';

import './styles.css';

const Doc = ({
  i,
  d,
  t,
  handleEdit,
  handleDelete,
  handleMoveUp,
  handleMoveDown,
}) => {
  return (
    <div className="doc">
      <div className="doc__image" style={{ paddingRight: '5px' }}>
        <DocPreview item={d} />
      </div>

      <div className="doc__info">
        <div>
          <Link onClick={handleEdit(d)}>{d.full || t('no type')}</Link>&nbsp;
          {d.details && (
            <span>
              {t('from')} {d.details.toFormatedDateString('L')}
            </span>
          )}
        </div>

        <p className="doc__info__original ms-font-xs">
          {t('Original name', {
            originalFilename: d.originalFilename,
            uploadedAt: new Date(d.uploadedAt),
          })}
        </p>
      </div>

      <div className="doc__actions">
        <Link onClick={handleMoveUp(d)}>
          <i className="ms-Icon ms-Icon--Up" aria-hidden="true"></i>
        </Link>
        <Link onClick={handleMoveDown(d)}>
          <i className="ms-Icon ms-Icon--Down" aria-hidden="true"></i>
        </Link>
        <Link onClick={handleEdit(d)}>
          <i className="ms-Icon ms-Icon--Edit" aria-hidden="true"></i>
        </Link>
        <Link onClick={handleDelete(d)}>
          <i className="ms-Icon ms-Icon--Delete" aria-hidden="true"></i>
        </Link>
      </div>
    </div>
  );
};

Doc.displayName = 'Doc';

export default localizable(Doc);



// WEBPACK FOOTER //
// ./src/app/containers/Sale/SaleEditSection/Doc.jsx